import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import * as Actions from './announcements.actions';
import * as AnnouncementsApi from './announcements.api';

import { AnnouncementManager } from './announcements.manager';

export const getAnnouncments = (action$) => {
  return action$.pipe(
    ofType(Actions.GET_ANNOUNCEMENTS),
    mergeMap(AnnouncementsApi.getAnnouncements),
    mergeMap((announcements) => {
      return of(Actions.getAnnouncementsSuccess(announcements));
    }),
  );
};

export const displayNotificationsForAnnouncements = (action$) => {
  return action$.pipe(
    ofType(Actions.GET_ANNOUNCEMENTS_SUCCESS),
    mergeMap(({ announcements }) => {
      if (announcements?.length) {
        announcements.forEach(AnnouncementManager.showAnnouncement);
      }
      return EMPTY;
    }),
  );
};
